const SOCIAL_PROFILES = {
  linked_in: 'LinkedIn Profile Link',
}

// RocketReach no longer provides LinkedIn profile pictures (IRW-8172).
// Mirrored in irwin-fe, admin-fe and irwin-api (lib/ds13.rb) — re-enabling requires all three.
export const SHOW_PERSON_PROFILE_PICTURES = false

export default SOCIAL_PROFILES
